import BScroll from '@better-scroll/core';
export default {
  name: 'BetterScroll',
  props: {
    betterScrollOption: {
      type: Object,
      default: function _default() {
        return {
          scrollY: true,
          click: true
        };
      }
    }
  },
  mounted: function mounted() {
    this.bs = new BScroll(this.$refs.scroll, {
      scrollY: true,
      click: true
    });
  },
  updated: function updated() {
    this.bs.destroy();
    this.bs = new BScroll(this.$refs.scroll, {
      scrollY: true,
      click: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.bs.destroy();
  },
  methods: {
    refresh: function refresh() {
      this.bs.refresh();
    }
  }
};